<div class="btn-group dropdown" role="toolbar">
  <button class="btn dropdown-toggle" [ngClass]="buttonClass" type="button" data-bs-toggle="dropdown" id="popover-menu-action-btn">
    <span>{{buttonText}}</span>
    <span class="caret"></span>
  </button>

  <ul class="dropdown-menu shadow"
    [ngClass]="{'dropdown-menu-end': dropdownDirection==='right', 'dropdown-menu-start': dropdownDirection==='left'}">

    @for (item of menuItems; track item) {
      @if (item?.divider) {
        <li role="separator" class="dropdown-divider"></li>
      } @else {
        @if (item.visible) {
          <li class="popover-menu-item" [ngClass]="{'disabled': item.disabled}"
            (click)="item?.action()">
            @if (item?.faIconClass) {
              <i class="fa" [ngClass]="item.faIconClass"></i>
            }
            <div class="text-content-container">
              <div class="item-title">{{item.title}}</div>
              <div class="item-subtitle">{{item.subtitle}}</div>
            </div>
          </li>
        }
      }
    }
  </ul>
</div>
